const paginators = document.querySelectorAll('.page-navigator');

paginators.forEach(paginator => {
  paginator.addEventListener('click', e => {
    const pageId = e.target.dataset.page;
    const pageUp = parseInt(pageId) + 10;
    const pageDown = parseInt(pageId) - 10;

    paginators.forEach(p => {
      p.classList.remove('bg-orange-mpf');
      p.classList.remove('hidden');
      if (p.dataset.page >= pageUp || p.dataset.page <= pageDown) {
        p.classList.add('hidden');
      }
    });
    paginator.classList.add('bg-orange-mpf');
  });
});
